import { ACCOUNT_SET_SKRITTER, SET_AUTHENTICATED, SET_UNAUTHENTICATED } from '../types'
import { LOGIN } from 'routes/routeConstant'
import axios from 'axios'
import { getSkritterWordPayload, refreshSkritterAuthToken } from 'services/skritter'
import store from '../store'
import posthog from 'posthog-js'
import { redirect } from 'react-router-dom'
import { logoutUser } from './authAction'
import axiosInstance from '../../axios/axiosInstance'
import { cancelAllRequests } from '../../utils/apiAbortManager'
import { REACT_APP_HACK_CHINESE_APP_KEY } from 'utils/config'
import { getIntegrationsToken } from 'utils/CheckAuthentication'
import { ONBOARDING_PERSIST_STORAGE_KEY } from '../store'
import { profileLanguageFields } from '../../i18n/languages'
import { syncLanguageWithProfile } from '../../i18n/profileLanguage'

//skritter apis

export const updateNewTokenToDB = async (payload) => {
  try {
    const response = await axiosInstance.put('skritter', payload)
    return response
  } catch (error) {
    throw error
  }
}

export const removeSkritterTokenForUser = async () => {
  try {
    const response = await axiosInstance.delete('skritter')
    return response
  } catch (error) {
    throw error
  }
}

export const registerWithSkritter = async (payload) => {
  try {
    const response = await axiosInstance.post('skritter', payload)
    return response.data
  } catch (error) {
    console.log('error', error)
    throw error
  }
}

// skritter apis end

// HackChinese apis

export const AddWordToHackChinese = async (payload: any) => {
  const data = {
    words: [
      {
        simplified: payload.word,
        pinyin: payload.pinyin,
      },
    ],
    user_auth_token: payload.user_auth_token,
  }
  try {
    const headers = {
      Authorization: REACT_APP_HACK_CHINESE_APP_KEY,
      'Content-Type': 'application/json',
    }
    // const response =
    await axios.post('https://www.hackchinese.com/add_words_to_user_list', data, {
      headers: headers,
    })
  } catch (error) {
    console.log('error', error)
  }
}

export const removeHackChineseTokenForUser = async (): Promise<any> => {
  try {
    const response = await axiosInstance.put('hack-chinese')
    return response
  } catch (error) {
    throw error
  }
}

export const postHackChineseTokenForUser = async (payload: any): Promise<any> => {
  try {
    const response = await axiosInstance.post('hack-chinese', {
      hack_chinese_token: payload,
    })
    return response
  } catch (error) {
    throw error
  }
}

// HackChinese apis end

// integrations apis

export const getIntegrationsTokenForUser = async () => {
  try {
    const response = await axiosInstance.get(`integrations`)
    return {
      hack_chinese_token: response.data?.hack_chinese_token,
      skritter_token: response.data?.skritter?.skritter_token || '',
      skritter: response.data?.skritter,
    }
  } catch (error) {
    console.log('error', error)
    throw error
  }
}

// integrations apis end

export const handleAddWordToSkritter = async (payload) => {
  const wordPayload = getSkritterWordPayload(payload)

  const skritter = store.getState().user.skritter
  const memberId = store.getState().user.membership.id

  const expires_in = skritter.expires_in ? parseInt(skritter.expires_in) : 0
  const cTimeSeconds = Math.floor(Date.now() / 1000)
  // expires_in was in seconds
  // if current time less than or equal to Skritter access_token's expiration  time (minus 2 Hour)
  // refetch new access_token
  if (cTimeSeconds >= expires_in - 7200) {
    try {
      const res: any = await refreshSkritterAuthToken(skritter.refresh_token)
      if (res.access_token) {
        payload.skritter_token = res.access_token
        // skritter_token = res.access_token
        payload.refresh_token = res.refresh_token
        payload.expires_in = (parseInt(res.expires_in) + cTimeSeconds).toString()

        const updatePayload = {
          skritter_token: res.access_token,
          refresh_token: res.refresh_token,
          expires_in: payload.expires_in.toString(),
          user_id: skritter.user_id,
          token_type: skritter.token_type,
        }
        // const updateRes =
        await updateNewTokenToDB(updatePayload)

        store.dispatch({
          type: ACCOUNT_SET_SKRITTER,
          payload: { token: res?.access_token || '', skritter: { ...updatePayload, memberId } },
        })
        localStorage.setItem('skritterData', JSON.stringify({ ...skritter, ...res, skritter_token: res.access_token }))
      }
    } catch (error) {}
  }

  const headers = {
    authorization: 'bearer ' + payload.skritter_token,
  }
  try {
    const response = await axios.post(`https://api.skritter.com/v3/vocabs/add-to-list`, wordPayload, {
      headers: headers,
    })
    return response.data
  } catch (error) {
    // console.log('error', error)
    throw error
  }
}

export const logout = async (callApi = false) => {
  if (callApi) {
    try {
      const res = await logoutUser()
      if (res?.status === 200) {
        cancelAllRequests()

        clearLocal(true)
        store.dispatch({
          type: SET_UNAUTHENTICATED,
        })

        posthog.reset(true)
        redirect(LOGIN)
      }
    } catch (e) {}
    return
  } else {
    cancelAllRequests()

    clearLocal(true)
    store.dispatch({
      type: SET_UNAUTHENTICATED,
    })

    posthog.reset(true)
    redirect(LOGIN)
  }
}

export const loginUserWithOtp = ({ userDetails, isSignup = false }) => {
  if (!userDetails) return

  const credentials = {
    memberId: userDetails?.id,
    email: userDetails?.email,
    createdAt: userDetails?.createdAt || null,
    metaData: {
      firstName: userDetails?.customFields?.firstName || '',
    },
    customFields: {
      level: userDetails?.customFields?.level || 'beginner',
      ...(userDetails?.customFields || {}),
      ...profileLanguageFields(userDetails?.customFields),
    },
  }
  const membership = {
    id: userDetails?.id,
    name: isSignup ? '' : userDetails?.membership?.name,
    amount: 0,
    oneTime: false,
    plan: userDetails?.membership?.name,
  }

  const userAuthObject = {
    credentials,
    membership,
    stripe: userDetails?.stripe,
    paymentProfile: userDetails?.paymentProfile,
    authToken: userDetails?.token,
    refreshToken: userDetails?.refresh_token,
    lastLogin: new Date().toISOString(),
    reminder: userDetails?.reminder,
    trialEligibility: userDetails?.trialEligibility || null,
    backToSchool2026: userDetails?.backToSchool2026 || null,
  }

  store.dispatch({
    type: SET_AUTHENTICATED,
    payload: userAuthObject,
  })

  localStorage.setItem('user', JSON.stringify(userAuthObject))
  localStorage.setItem('authToken', userAuthObject.authToken)
  syncLanguageWithProfile(credentials)

  getIntegrationsToken()
  // Clear story state to prevent unwanted redirects
  store.dispatch({ type: 'SET_STORY', payload: {} })
  store.dispatch({ type: 'SET_PREVENT_REDIRECT', payload: true })
}

export const clearLocal = (clearToken = true) => {
  if (clearToken) {
    localStorage.removeItem('authToken')
  }
  localStorage.removeItem('user')
  localStorage.removeItem('skritterData')
  localStorage.removeItem('persist:storymaayot')
  localStorage.removeItem('persist:quizmaayot')
  localStorage.removeItem('persist:questionmaayot')
  localStorage.removeItem('persist:streakmaayot')
  localStorage.removeItem('persist:levelmaayot')
  localStorage.removeItem(ONBOARDING_PERSIST_STORAGE_KEY)
  // The teacher desk keeps learners' answers and drafts for instant loading: never past a log out.
  Object.keys(localStorage)
    .filter((key) => key.startsWith('teacherDesk.'))
    .forEach((key) => localStorage.removeItem(key))
}
